<template>
  <div>
    <div class="row">
      <div class="col-md-4 mb-4">
        <info-card
          :title="'Contas a receber este mês'"
          icon="fa-calendar-day"
          variant="sucess"
          :value="todayReceivebleTotal.sum_net_total"
        />
      </div>
      <div class="col-md-4 mb-4">
        <info-card
          :title="'Total de contas a receber'"
          icon="fa-calendar-day"
          variant="primary"
          :value="monthReceivebleTotal.sum_net_total"
        />
      </div>

      <div class="col-md-4 mb-4">
        <info-card
          :title="'Total de contas vencidas'"
          icon="fa-calendar-day"
          variant="danger"
          :value="overdueReceivebleTotal.sum_net_total"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-4">
        <div class="card">
          <div class="card-body">
            <span class="text-muted">Contas a receber</span>
            <hr />
            <bill-receiveble-historic-chart :data="ReceivebleTotalByMonth" />
            <!-- <app-bar-chart :series="accountTransactionSeries" :categories="accountTransactionLabels"/> -->
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <table-paginator :data="ReceivebleByVendor" @pagechange="selectVendorRank($event)">
                  <span class="text-muted">Ranking de Clientes</span>
                  <hr />
                  <div
                    class="row mb-4"
                    v-for="(row, index) in ReceivebleByVendor.data"
                    :key="index"
                  >
                    <div class="col-6">
                      <template v-if="row.name != null">
                        <avatar
                          inline
                          color="#fff"
                          :size="30"
                          :username="row.name"
                          :initials="row.name.slice(0, 1)"
                        ></avatar>
                        <span style="margin-left:10px">{{ row.name }}</span>
                      </template>
                      <template v-else>
                        <avatar
                          inline
                          color="#fff"
                          :size="30"
                          :username="'Consumidor Final'"
                          :initials="'CF'"
                        ></avatar>
                        <span style="margin-left:10px">Cliente Não Indentificado</span>
                      </template>
                    </div>
                    <div class="col-6 text-right">{{ row.sum_net_total | decimal}}</div>
                  </div>
                </table-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <span class="text-muted">Resumo contas a receber</span>
            <hr />
            <div class="row">
              <div class="col-md-4">
                <date-input v-model="searchForm.start_date" alias="Data Inicial" />
              </div>
              <div class="col-md-4">
                <date-input v-model="searchForm.end_date" alias="Data Final" />
              </div>
              <div class="col-md-4 d-flex align-items-end">
                <div class="form-group">
                  <button type="button" class="btn btn-sm btn-primary" @click="selectbill()">
                    <i class="fas fa-search" /> Pesquisar
                  </button>
                </div>
              </div>
            </div>
            <hr />
            <template>
              <div class="row">
                <div class="col-md-6">Vendas no Crediario:</div>
                <div class="col-md-6 text-right">{{reportbillByPeriod.sum_net_total | decimal}}</div>
              </div>
              <div class="row">
                <div class="col-md-6">Contas Canceladas:</div>
                <div class="col-md-6 text-right">{{reportbillCanceledByPeriod.sum_net_total | decimal}}</div>
              </div>
              <div class="row">
                <div class="col-md-6">Contas Vencidas:</div>
                <div class="col-md-6 text-right">{{reportdueByPeriod.sum_net_total | decimal}}</div>
              </div>

            </template>
          </div>
        </div>
      </div>
    </div>

    <br />

    <error-handler :error="error" />
  </div>
</template>

<script>
import TablePaginator from "./../sections/TablePaginator.vue";
import InfoCard from "./../sections/dashboard/InfoCard.vue";
import AppBarChart from "./../ui/AppBarChart.vue";
import BillReceivebleHistoricChart from "./../charts/BillReceivebleHistoricChart.vue";
import Filter from "./../../mixins/Filters";
import Avatar from "vue-avatar";

export default {
  components: {
    TablePaginator,
    InfoCard,
    AppBarChart,
    BillReceivebleHistoricChart,
    Avatar
  },

  data: function() {
    return {
      searchForm: {
        start_date: null,
        end_date: null
      },

      series: [
        {
          data: []
        },
        {
          data: []
        }
      ],

      reportdueByPeriod: {},

      reportbillByPeriod: {},

      reportbillCanceledByPeriod: {},

      todayReceivebleTotal: {},

      monthReceivebleTotal: {},

      ReceivebleTotalByMonth: {},

      ReceivebleByVendor: {
        data: []
      },

      overdueReceivebleTotal: {},

      orderBySalesman: {},
      // accountTransactionsOut : [],
      // accountTransactionsIn : [],

      error: null,

      orderTotalByMonth: {}
    };
  },

  created() {
    axios
      .post("api/dashboard/billreceiveble/select")
      .then(response => {
        this.todayReceivebleTotal = response.data.todayReceivebleTotal;
        this.monthReceivebleTotal = response.data.monthReceivebleTotal;
        this.ReceivebleTotalByMonth = response.data.ReceivebleTotalByMonth;
        this.overdueReceivebleTotal = response.data.overdueReceivebleTotal;
        this.ReceivebleByVendor = response.data.ReceivebleByVendor;

        this.$store.commit("pageHasLoaded");
      })
      .catch(error => {
        this.error = error;
        this.$store.commit("pageHasLoadedWithError", {
          error: error
        });
      });
  },

  computed: {
    accountTransactionSeries() {
      let series = [];
      let labels = [];

      series[0] = {};
      series[0].name = "Entradas";
      series[0].data = this.accountTransactionsIn.map(elem => elem.sum_value);

      series[1] = {};
      series[1].name = "Saidas";
      series[1].data = this.accountTransactionsOut.map(
        elem => elem.sum_value * -1
      );

      return series;
    },

    accountTransactionLabels() {
      let labelsIn = this.accountTransactionsOut.map(elem => elem.paid_at);
      return labelsIn;
    }
  },

  methods: {
    selectVendorRank(page = 1) {
      axios
        .post("api/dashboard/billreceiveble/listclient?page=" + page)
        .then(response => {
          this.ReceivebleByVendor = response.data;
          console.log(response.data);

          this.$store.commit("pageHasLoaded");
        })
        .catch(error => {
          this.error = error;
          this.$store.commit("pageHasLoadedWithError", {
            error: error
          });
        });
    },

    selectbill() {
      axios
        .post("api/dashboard/billreceiveble/selectbill", this.searchForm)
        .then(response => {
          this.reportdueByPeriod = response.data.dueByPeriod;

          this.reportbillByPeriod = response.data.billByPeriod;

          this.reportbillCanceledByPeriod = response.data.billCanceledByPeriod;


        })
        .catch(error => {
          this.error = error;
          this.$store.commit("pageHasLoadedWithError", {
            error: error
          });
        });
    },

    getAccountBalance(id) {
      if (this.accountsBalance[id] == null) {
        return 0;
      }
      return this.accountsBalance[id].balance;
    }
  }
};
</script>

<style>
</style>
